import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=034c510b&scoped=true&"
import script from "./Brands.vue?vue&type=script&setup=true&lang=js&"
export * from "./Brands.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=034c510b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c510b",
  null
  
)

export default component.exports